import { Link } from 'react-router-dom';

interface RelatedItem {
  to: string;
  image: string;
  aspect: string;
  alt: string;
  title: string;
  desc: string;
}

interface RelatedCardsProps {
  heading: string;
  items: RelatedItem[];
  readLabel: string;
  backHref: string;
  backLabel: string;
}

const BTN08_ON_LIGHT = "relative inline-flex items-center justify-center bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#a38e65]/45 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#1a2942]/45";

/**
 * 次に読む＝関連記事カード群。記事末尾に配置し一覧へ戻る導線も持つ。
 */
export default function RelatedCards({ heading, items, readLabel, backHref, backLabel }: RelatedCardsProps) {
  return (
    <section className="bg-[#f8f6f0] border-t border-[#e2ddd2]">
      <div className="max-w-4xl mx-auto px-6 py-14">
        <h2 className="jba-display font-medium text-[#1a2942] text-2xl mb-8">{heading}</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {items.map((r) => (
            <Link to={r.to} key={r.to} className="group bg-white border border-[#e2ddd2] overflow-hidden hover:border-[#a38e65]/60 transition-colors">
              <div className="overflow-hidden">
                <img src={r.image} alt={r.alt} className={`object-cover group-hover:scale-105 transition-transform duration-500 w-full h-auto ${r.aspect}`} />
              </div>
              <div className="p-5">
                <h3 className="jba-display font-normal text-[#1a2942] text-base leading-[1.6] group-hover:text-[#8f7a56] transition-colors">{r.title}</h3>
                <p className="mt-2 text-[#666] text-[13px] font-['Noto_Serif_JP',serif] leading-[1.8]">{r.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm text-[#8f7a56] font-['Noto_Serif_JP',serif]">{readLabel} <span className="text-[#a38e65] group-hover:translate-x-1 transition-transform inline-block">&rarr;</span></span>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-12">
          <a href={backHref} className={BTN08_ON_LIGHT}>{backLabel}</a>
        </div>
      </div>
    </section>
  );
}
